import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';

import Global from '../../store/global-selectors';
import { getUserFriendlyMessagesForErrorResponse } from '../../errors/user-friendly-error-message-service';
import { useEntitiesFulfillmentPlanProperty } from '../../hooks/entities/selectors/fulfillment-plans';
import { updateFulfillmentPlansIsGift } from '../../fulfillment-plans/fulfillment-plans.api';
import { entitiesBulkload } from '../../store/entities/entities.actions';
import { processEntities } from '../../store/entities/entities.bulkload';

import style from './style.module.css';

const messages = defineMessages({
  thisIsAGift: {
    description: 'orderDetails.thisIsAGift',
    defaultMessage: 'This is a gift',
    id: 'EVXi2e',
  },
});

const GIFT_PROPERTY_KEY = 'isGift';

const OrderSummaryGiftCheckbox = ({ salesOrderId }) => {
  const dispatch = useDispatch();
  const salesOrder = useSelector((state) => Global.selectEntitiesSalesOrderById(state, { salesOrderId }) || {});
  const fulfillmentPlanIds = useMemo(() => salesOrder?.fulfillmentPlanIds || [], [salesOrder]);
  const firstFulfillmentPlanId = useMemo(() => (fulfillmentPlanIds.length > 0 ? fulfillmentPlanIds[0] : null), [fulfillmentPlanIds]);
  const giftValue = useEntitiesFulfillmentPlanProperty(firstFulfillmentPlanId || '', GIFT_PROPERTY_KEY);
  const isGift = firstFulfillmentPlanId ? giftValue : false;

  const updateEntities = useCallback(
    (fulfillmentPlans) => {
      dispatch(entitiesBulkload(processEntities({ fulfillmentPlans })));
    },
    [dispatch],
  );

  const toggleGift = useCallback(async () => {
    if (!fulfillmentPlanIds.length) {
      return;
    }
    try {
      const { data: updatedEntityFulfillmentPlans } = await updateFulfillmentPlansIsGift(fulfillmentPlanIds, !isGift);
      updateEntities(updatedEntityFulfillmentPlans);
    } catch (error) {
      getUserFriendlyMessagesForErrorResponse(error);
    }
  }, [isGift, fulfillmentPlanIds, updateEntities]);

  return (
    <Checkbox
      checked={isGift}
      className={style['gift-checkbox']}
      label={<FormattedMessage {...messages.thisIsAGift} />}
      onChange={toggleGift}
    />
  );
};

OrderSummaryGiftCheckbox.propTypes = {
  salesOrderId: PropTypes.string.isRequired,
};

export default OrderSummaryGiftCheckbox;
